<template>
  <div class="filling-window bg-white fixed w-full h-full flex items-center justify-center z-10">
    <div class="relative w-full h-full">
      <div class="h-full flex flex-col items-center p-[22px]">
        <div class="py-4 text-xl">{{ t('fueling') }}</div>
        <div class="text-gray-400 font-light pb-4">{{ t('wait') }}...</div>
        <div class="filling-block my-20">
          <span :class="{
            'text-white': percent > 10,
            'text-[#ec833f]': percent <= 10
          }">{{ t('refueling') }} <AnimatedNumber :number="percent" />%</span>
          <div class="liquid"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import Service from '@/request/service.js'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AnimatedNumber from '@/views/tanker/AnimatedNumber.vue'

const interval = ref()
const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const percent = ref(0)
const fillingPercent = computed(() => (50 - percent.value) + '%')

onMounted(() => {
  interval.value = setInterval(() => {
    const params = {
      station_id: route.params.station,
      column_id: route.params.column,
      litre: route.params.capacity,
      fuel: route.params.fuel,
      uuid: route.params.uuid,
      status: 1
    }
    Service.paymentDetails(route.params.store, params).then(({ data: response }) => {
      const litre = response.data.find(d => d.key === 'litre')
      const status = response.data.find(d => d.key === 'status')
      if (status?.value === 'progress') {
        percent.value = parseInt(litre?.value / route.params.capacity * 100)
      }
      if (status?.value === 'completed') {
        clearInterval(interval.value)
        router.push({
          name: 'tanker-result',
          params: route.params
        })
      }
    }).catch(e => console.log(e)).finally(() => {})
  }, 1000)
})
</script>

<style lang="scss">
body {
  background-color: #F4F4F7;
}
</style>

<style scoped>
.filling-window {
  font-family: 'HelveticaNowDisplay',
  -apple-system,
  system-ui,
  BlinkMacSystemFont,
  'Segoe UI',
  Roboto,
  Oxygen,
  Ubuntu,
  Cantarell,
  'Fira Sans',
  'Droid Sans',
  'Helvetica Neue',
  sans-serif !important;
}
.filling-block {
  width: 200px;
  height: 300px;
  display: block;
  padding: 10px 0;
  overflow: hidden;
  text-align: center;
  position: relative;
  border-radius: 55px;
  text-decoration: none;
}

.filling-block span {
  left: 0;
  z-index: 1;
  width: 100%;
  bottom: 20px;
  font-size: 16px;
  position: absolute;
  font-weight: 300;
  transition: all 0.2s ease;
}

.filling-block .liquid {
  top: 0;
  left: 0;
  width: 200px;
  height: 300px;
  transition: 1s;
  position: absolute;
  background: #ec833f;
}

.filling-block .liquid::after,
.filling-block .liquid::before {
  top: v-bind(fillingPercent);
  left: 50%;
  content: '';
  width: 300%;
  height: 200%;
  position: absolute;
  transition: top 3s ease 0s;
}

.filling-block .liquid::before {
  border-radius: 48%;
  background: rgba(244, 244, 244, 1);
  animation: animate 5s linear infinite;
}

.filling-block .liquid::after {
  border-radius: 46%;
  background: rgba(244, 244, 244, .5);
  animation: animate 10s linear infinite;
}

@keyframes animate {
  0% {
    transform: translate(-50%, -75%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -75%) rotate(360deg);
  }
}
</style>